var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { SheetRowPredicateType } from '../../../../../common/api';
function mapSheetRowPredicateToPredicateRepresentationRecursive(predicate, result) {
    var e_1, _a;
    var index = result.length;
    if (predicate.type === SheetRowPredicateType.DimensionTag) {
        var element = {
            type: SheetRowPredicateType.DimensionTag,
            dimensionTagId: predicate.dimensionTagId,
        };
        result.push(element);
    }
    else if (predicate.type === SheetRowPredicateType.Downstream) {
        var element = {
            type: SheetRowPredicateType.Downstream,
            fromTableTagId: predicate.fromTableTagId,
            toTableTagId: predicate.toTableTagId,
        };
        result.push(element);
    }
    else {
        var type = void 0;
        if (predicate.type === SheetRowPredicateType.And) {
            type = SheetRowPredicateType.And;
        }
        else if (predicate.type === SheetRowPredicateType.Or) {
            type = SheetRowPredicateType.Or;
        }
        else {
            type = SheetRowPredicateType.Not;
        }
        var children = [];
        var element = {
            type: type,
            children: children,
        };
        result.push(element);
        try {
            for (var _b = __values(predicate.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                var childId = mapSheetRowPredicateToPredicateRepresentationRecursive(child, result);
                children.push(childId);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return index;
}
export function mapSheetRowPredicateToPredicateRepresentation(predicate) {
    if (predicate === null) {
        return null;
    }
    var result = [];
    mapSheetRowPredicateToPredicateRepresentationRecursive(predicate, result);
    return result;
}
export function toSheetRowPredicate(predicate) {
    var e_2, _a, e_3, _b;
    if (predicate === null || predicate.length === 0) {
        return null;
    }
    var nodes = [];
    try {
        for (var predicate_1 = __values(predicate), predicate_1_1 = predicate_1.next(); !predicate_1_1.done; predicate_1_1 = predicate_1.next()) {
            var element = predicate_1_1.value;
            if (element.type === SheetRowPredicateType.DimensionTag) {
                if (element.dimensionTagId === undefined) {
                    throw new Error('Invalid predicate');
                }
                var node_1 = {
                    type: SheetRowPredicateType.DimensionTag,
                    dimensionTagId: element.dimensionTagId,
                };
                nodes.push(node_1);
                continue;
            }
            if (element.type === SheetRowPredicateType.Downstream) {
                if (element.fromTableTagId === undefined || element.toTableTagId === undefined) {
                    throw new Error('Invalid predicate');
                }
                var node_2 = {
                    type: SheetRowPredicateType.Downstream,
                    fromTableTagId: element.fromTableTagId,
                    toTableTagId: element.toTableTagId,
                };
                nodes.push(node_2);
                continue;
            }
            if (element.type === SheetRowPredicateType.And) {
                var node_3 = {
                    type: SheetRowPredicateType.And,
                    children: [],
                };
                nodes.push(node_3);
                continue;
            }
            if (element.type === SheetRowPredicateType.Or) {
                var node_4 = {
                    type: SheetRowPredicateType.Or,
                    children: [],
                };
                nodes.push(node_4);
                continue;
            }
            var node = {
                type: SheetRowPredicateType.Not,
                children: [],
            };
            nodes.push(node);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (predicate_1_1 && !predicate_1_1.done && (_a = predicate_1.return)) _a.call(predicate_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        var element = predicate[i];
        if (node.type === SheetRowPredicateType.DimensionTag || node.type === SheetRowPredicateType.Downstream) {
            continue;
        }
        if (element.children === undefined) {
            throw new Error('Invalid predicate');
        }
        try {
            for (var _c = (e_3 = void 0, __values(element.children)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var childElementId = _d.value;
                if (childElementId <= i) {
                    throw new Error('Invalid predicate');
                }
                var childElement = predicate[childElementId];
                if (childElement === undefined) {
                    throw new Error('Invalid predicate');
                }
                var childNode = nodes[childElementId];
                if (childNode === undefined) {
                    throw new Error('Invalid predicate');
                }
                node.children.push(childNode);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
    }
    return nodes[0];
}
